import { prefixer, createApiConsts } from '../../../../../Helpers/constants'

const createPrefixedConst = prefixer('METADATA_FILTER')
const createPrefixedApiConsts = <ApiName extends string>(apiName: ApiName) => createApiConsts(createPrefixedConst(apiName))

export const GET_FIELDS = createPrefixedApiConsts('GET_FIELDS')
export const GET_OPERATORS = createPrefixedApiConsts('GET_OPERATORS')

export const OPERATOR_TYPES = {
  DATE: 'date',
  TEXT: 'text',
  HYPERLINK: 'projectHyperLinkTitle',
  NUMBER: 'number',
}

export const MAPPED_OPERATOR_TYPES = {
  [OPERATOR_TYPES.DATE]: 'Date',
  [OPERATOR_TYPES.TEXT]: 'Text',
  [OPERATOR_TYPES.HYPERLINK]: 'HyperLink',
  [OPERATOR_TYPES.NUMBER]: 'Number',
}

export const DATE_FORMAT = 'MM/DD/YYYY'
